import { Stack, Typography } from "@mui/material";

const ZoomOnlyChip = () => (
  <Stack
    sx={{
      borderRadius: "8px",
      px: 1,
      py: 0.5,
      bgcolor: "#008FFF",
      color: "white",
      textTransform: "uppercase",
    }}
  >
    <Typography
      variant="labelMed"
      sx={{ whiteSpace: "nowrap", lineHeight: 1.5 }}
    >
      Zoom only
    </Typography>
  </Stack>
);

export default ZoomOnlyChip;
